export default {
  Title: 'Activity Log',

  Table: {
    Button: {
      View: {
        Title: 'View Activity Log',
        Icon : 'remove_red_eye',
        Color: 'cyan'
      }
    },

    Headers: {
      Id         : '#',
      Name       : 'Type',
      Description: 'Action',
      SubjectName: 'Value',
      User       : 'User',
      IpAddress  : 'IP Address',
      UserAgent  : 'Browser',
      Date       : 'Date',
      Actions    : ''
    },

    Filter: {
      filterAction: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Action',
        PlaceHolder: 'All activity logs',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },
      filterUser: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Users',
        PlaceHolder: 'All activity logs',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        Items      : []
      },
      filterDate: {
        Type       : 'v-date-picker',
        Label      : 'Date',
        PlaceHolder: 'Select Date',
        Icon       : 'event'
      }
    }
  },

  Dialog: {
    View: {
      Toolbar: {
        Title   : 'Activity Log',
        Subtitle: '',
        Icon    : 'mdi-history'
      }
    }
  }
}
